export const autocloseSidebar = ({ className, event }) => (state, actions) => {
  if (
    state.sidebar.active === true &&
    !event.target.classList.contains(className)
  ) {
    actions.toggleSidebarState({ event });
  }
};
